import { render } from "./purchasess.vue?vue&type=template&id=22ee4c9f"
import script from "./purchasess.vue?vue&type=script&lang=js"
export * from "./purchasess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__